"use strict";

var ga_track = function ga_track(category, action, label) {
  if (typeof gtag !== 'undefined') {
    gtag('event', action, {
      'event_category': category,
      'event_label': label.toLowerCase(),
      'value': 1
    });
  }
};

// Anchor tracking
var anchors = document.querySelectorAll('a');

for (var i = 0; i < anchors.length; i += 1) {
  /**
   * Use closure/IIFE to define the scope of i as a private variable
   * This prevents losing the i's exact value, specific for the event listener function
   * */
  (function (index) {
    var url = anchors[index].getAttribute('href');
    var title = anchors[index].innerText; // Checks

    if (url) {
      var isPDF = url.includes('pdf');
      var isDomain = url.includes(window.location.hostname);
      var hasHash = url.includes('#');
      var isTel = url.includes('tel');
      var isMail = url.includes('mailto');
      var startsWithSlash = url.startsWith('/');

      anchors[index].addEventListener('click', function (event) {
        switch (true) {
          // Open external URLs in a new window, excluding tel or mailto
          case !isDomain && !startsWithSlash && url !== '/' && !hasHash && !isTel && !isMail || isPDF:
            event.preventDefault(); // If PDF, assign different tracking category

            var category = isPDF ? 'PDF' : 'link';
            ga_track(category, 'click', url);
            window.open(url);
            break;

          case isTel:
            ga_track('phone', 'click', url);
            break;

          case isMail:
            ga_track('email', 'click', url);
            break;

          default:
            ga_track('link', 'click', "".concat(title ? title : url));
            break;
        }
      });
    }
  })(i);
}
